<template>
    <div class="rule-value-table">
        <section class="rule-value-title" data-qa="rule-value-title">
            {{ $t('funnel.debug.ruleValue') }}
        </section>

        <DsTableGrid
            ref="ruleValuesRef"
            :data="ruleValues"
            data-qa="rule-value-grid"
        >
            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.id')"
                prop="Id"
                width="80"
                data-qa="column-id"
            />

            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.draft.rule.id')"
                prop="RuleId"
                width="100"
                data-qa="column-rule-id"
            />

            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.draft.order')"
                prop="Order"
                width="60"
                data-qa="column-order"
            />

            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.draft.value')"
                prop="Value"
                width="60"
                data-qa="column-value"
            />

            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.content.publishing.id')"
                prop="ContentPublishingId"
                width="100"
                data-qa="column-content-publishing-id"
            />

            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.date.created')"
                prop="DateCreated"
                width="80"
                data-qa="column-date-created"
            />

            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.last.updated')"
                prop="LastUpdated"
                width="80"
                data-qa="column-last-updated"
            />
        </DsTableGrid>
    </div>
</template>

<script>
export default {
    props: {
        ruleValues: {
            type: Array,
            required: true,
        },
    },
};

</script>

<style lang="scss" scoped>
.rule-value-table {
    :deep(th .cell) {
        word-wrap: break-word;
        white-space: break-spaces;
    }

    .rule-value-title {
        font-weight: bold;
        margin: $spacing-250 0 $spacing-250 0;
    }
}
</style>
